module.exports = __webpack_public_path__ + "img/md-return-right.a4b78bd3.svg";